import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../components/UI/Spinner';
import { openAlert } from '../utils/common';
import { useAuth } from '../context/AuthContext';

const defaultHomeByRole = (role) => {
  if (role === 'calibration_operator') return '/calibration/queue';
  return '/settings/dashboard';
};

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <Spinner loading={true} />;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const role = user?.role || '';
  if (!allowedRoles.includes(role)) {
    openAlert({ title: '권한 없음', description: '접근 권한이 없습니다.' });
    return <Navigate to={defaultHomeByRole(role)} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
